export default __webpack_public_path__ + "static/media/grafema_capitolio_01.0a0af182.mp4";